import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdjuntoComponent } from './adjunto.component';
import { SharedPipesModule } from '@shared/pipes/shared-pipes.module';



@NgModule({
  declarations: [
    AdjuntoComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    SharedPipesModule,
  ],
  exports:[
    AdjuntoComponent,
  ]
})
export class AdjuntoModule { }
